import {
    CreativeTypes,
    VIDEO_MAX_CHARACTERS,
    IMAGE_MAX_CHARACTERS,
    CREATIVE_MAX_DURATION_SECONDS,
    getImageMaxDimensions,
    getVideoMaxDimensions,
} from '@bynder-studio/render-core';
import { getEnvironment } from './getEnvironment';
import { getHostConfig } from './hostConfig';

export const envVar = {
    get wsEndpoint(): string {
        const { wsEndpoint } = getHostConfig();

        if (wsEndpoint) {
            return wsEndpoint;
        }

        const env = getEnvironment();

        if (env === 'development') {
            return 'ws.development.weadapt.digital';
        }

        if (env === 'acceptance') {
            return 'ws.acceptance.weadapt.digital';
        }

        // Region fallback for the iframe deployment — see `hostConfig`. The
        // customer's portal hostname does not carry the `.eu.` / `.us.` marker,
        // so hosts embedding Studio must supply `wsEndpoint` explicitly.
        const { hostname } = window.location;

        if (hostname.includes('.eu.')) {
            return 'ws.eu.weadapt.digital';
        }

        if (hostname.includes('.us.')) {
            return 'ws.us.weadapt.digital';
        }

        return 'ws.weadapt.digital';
    },
    get googleAnalyticsId(): string {
        const env = getEnvironment();

        if (env === 'development') {
            return '';
        }

        if (env === 'acceptance') {
            return 'GTM-T4DZLS5';
        }

        return 'GTM-NL5BHHS';
    },
    appcuesAccountId: '17583',
    gatewayPrefix: '/gateway',
    sentryDsn: 'https://f087947988e143e2aeae6f16f6adf6f3@sentry10.bynder.cloud/1256',
    authRefreshTimeout: 600000,
    appVersionCheckIntervalSeconds: 3600,
    // Getters, not snapshots: the image ceiling is raised during login by
    // fetchImageMaxDimensionsFeatureTreatment. The video one is fixed, read the same way.
    get imageMaxDimensions(): number {
        return getImageMaxDimensions();
    },
    get videoMaxDimensions(): number {
        return getVideoMaxDimensions();
    },
    imageMaxCharacters: IMAGE_MAX_CHARACTERS,
    videoMaxCharacters: VIDEO_MAX_CHARACTERS,
    creativeMaxDurationSeconds: CREATIVE_MAX_DURATION_SECONDS,
    designMaxDimensions(creativeType: CreativeTypes) {
        return creativeType === CreativeTypes.VIDEO ? this.videoMaxDimensions : this.imageMaxDimensions;
    },
    designMaxCharacters(creativeType: CreativeTypes) {
        return creativeType === CreativeTypes.VIDEO ? this.videoMaxCharacters : this.imageMaxCharacters;
    },
};
